import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import useReveal from "@/hooks/useReveal";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import WhyChooseUs from "@/components/WhyChooseUs";
import Contact from "@/components/Contact";
import Faq from "@/components/Faq";
import Footer from "@/components/Footer";
import FloatingCTA from "@/components/FloatingCTA";

const HomePage = () => {
  useReveal();
  return (
    <main data-testid="home-page" className="App text-luxuryBlack">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <WhyChooseUs />
      <Contact />
      <Faq />
      <Footer />
      <FloatingCTA />
    </main>
  );
};

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#ffffff",
            color: "#000000",
            border: "1px solid rgba(231,84,128,0.30)",
            borderRadius: "16px",
            boxShadow: "0 0 32px rgba(231,84,128,0.22), 0 12px 36px rgba(167,74,199,0.20)",
          },
        }}
      />
    </>
  );
}

export default App;
